import { _ as __read } from '../../../_tslib-7a01aab4.js';
import { observer } from 'mobx-react-lite';
import React, { useState, useRef, useEffect } from 'react';
import '../../core/enums/GameSpecificTypes.js';
import '../../core/enums/MaxPayoutDataTypes.js';
import '../../core/enums/Chat.js';
import '../../core/enums/GameModes.js';
import '../../core/enums/IconTypes.js';
import '../../core/enums/BetStatus.js';
import '../../core/enums/PopupTypes.js';
import '../../core/enums/ApiVersion.js';
import '../../core/enums/RoundStatus.js';
import '../../core/enums/FreeBetsStatus.js';
import '../../core/enums/SocketEvents.js';
import '../../core/enums/TranslationKeys.js';
import '../../core/enums/TimeoutMaxValue.js';
import '../../core/enums/ApiServiceTypes.js';
import '../../core/enums/EnvironmentTypes.js';
import '../../core/enums/DefaultQueryValues.js';
import '../../core/enums/FreeBetWinningType.js';
import '../../core/enums/DefaultQueryParams.js';
import '../../core/enums/BetHistoryFilterTypes.js';
import '../../core/enums/GameThemeTypes.js';
import '../../core/enums/RequestStatus.js';
import '../../core/enums/FetchDefaultPaths.js';
import '../../core/enums/ResponseCodes.js';
import '../../../validateBalanceOnBet-af4f4a9b.js';
import '../../core/store/chatStore.js';
import '../../core/store/wageringStore.js';
import '../../core/store/roundInfoStore.js';
import '../../core/store/userCountStore.js';
import '../../core/store/gameResultStore.js';
import '../../core/store/resultHashStore.js';
import '../../core/store/userWinBetsStore.js';
import '../../core/store/notificationStore.js';
import '../../core/store/selectedResultInfoStore.js';
import '../../core/store/forCrashGame/inputValidationStore.js';
import '../../core/store/forCrashGame/totalBetStore.js';
import { oddStore } from '../../core/store/forCrashGame/resultReportStore.js';
import '../../core/store/forCrashGame/gameStore.js';
import '../../core/services/liveConnection/types.js';
import 'axios';
import '../../core/services/sound/types.js';
import '../../core/services/sound/SoundService.js';
import '../../core/services/sound/defaultSounds.js';
import '../../core/services/api/types.js';
import '../../core/services/ApiServices.js';
import '../../../momentFormat-e9197995.js';
import '../../core/polyfill.js';
import 'mobx';
import '../../core/classes/httpResponse/index.js';
import '@microsoft/signalr';
import '../../core/enums/BogLineGameConfig.js';
import '../../core/helpers/parseQuery.js';
import '../../core/enums/StatisticsSortingTypes.js';
import '../../core/services/api/BaseApiService.js';
import '../../core/helpers/deepCopy.js';
import '../../../table-line/t_types/enums/BetResponseCode.js';
import '../../../table-line/t_types/enums/BetErrorMessages.js';
import '../../../table-line/t_types/enums/NotificationByResponseCode.js';
import '../../../table-line/t_types/enums/FreeChipTypes.js';
import '../../../table-line/t_types/enums/PopupTypes.js';
import '../../core/helpers/formatDate.js';
import '../../core/helpers/isMobile.js';
import '../../core/enums/bogGameNames.js';
import '../../core/helpers/updateHalfBets.js';
import 'howler';
import '../../../_commonjsHelpers-17aad09c.js';

var RenderOdd = observer(function () {
    var oddData = oddStore.oddData, isCrash = oddStore.isCrash;
    var _a = __read(useState(oddData || 1), 2), displayedOdd = _a[0], setDisplayedOdd = _a[1];
    var previousOddRef = useRef(displayedOdd);
    useEffect(function () {
        // When oddStore.oddData updates, animate from the previous value to the new value.
        var targetOdd = oddData || null;
        var durationMs = 150;
        var startTime = 0;
        var animationFrameId;
        var animate = function (timestamp) {
            if (!startTime && oddData) {
                startTime = timestamp;
                previousOddRef.current = displayedOdd;
            }
            var progress = Math.min((timestamp - startTime) / durationMs, 1);
            var newValue = previousOddRef.current + (targetOdd - previousOddRef.current) * progress;
            setDisplayedOdd(function () {
                if (newValue < 1) {
                    return newValue + 1;
                }
                return newValue;
            });
            if (progress < 1) {
                animationFrameId = requestAnimationFrame(animate);
            }
            else {
                previousOddRef.current = targetOdd;
            }
        };
        animationFrameId = requestAnimationFrame(animate);
        return function () { return cancelAnimationFrame(animationFrameId); };
    }, [oddData]);
    return (!!displayedOdd &&
        (displayedOdd > 1 || isCrash) && (React.createElement("span", { className: "game-coefficient  ".concat(isCrash ? 'type2' : 'type1') },
        "x",
        displayedOdd.toFixed(2))));
});

export { RenderOdd };
